import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { countryDataInfo } from "../countryInfo";

@Injectable({
  providedIn: "root",
})
export class AdminService {
  public baseUrl: string = "https://india-live-api.talentasker.com";
  showLoader = new BehaviorSubject(false);
  public selectCountry : any;
  cdinfo = countryDataInfo;
  constructor(
    private http: HttpClient) {
      let cinfo = localStorage.getItem('CountryInfo');
      if(cinfo){
        this.selectCountry = JSON.parse(cinfo);
        let obj = JSON.parse(cinfo);
        this.baseUrl = obj.baseUrl;
      }else{
        this.selectCountry = this.cdinfo["india@talentasker.com"]
        this.baseUrl = this.selectCountry.baseUrl;
        localStorage.setItem("CountryInfo", JSON.stringify( this.selectCountry));
      }
    }

  adminLogin(data,token) {
    return this.http.post(
      `${this.baseUrl}/api/admin/login`,
      data ,{ headers: { talentasker: token } }
    );
  }
  getDefaultToken(userid){
    let data = {
      userID : userid
    }
    return this.http.post(
      `${this.baseUrl}/api/admin/defaultVerificationTokengenerate`,
      data
    );
  }
  updateMobileNumber(data, token): Observable<any> {
    return this.http.put(
      `${this.baseUrl}/api/customer/updatemobileno`,
      data,
      { headers: { talentasker: token } }
    );
  }
  // Dash Board Api's
  fetchStatus(token): Observable<any> {
    console.log(token);
    return this.http.get(`${this.baseUrl}/api/admin/QuickStatus`, {
      headers: { talentasker: token },
    });
  }
  fetchBookingStatus(data, token): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/admin/totalBookings`, data, {
      headers: { talentasker: token },
    });
  }
  fetchCategoryStatus(data, token): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/admin/postjobsFilter`, data, {
      headers: { talentasker: token },
    });
  }
  fetchlocationBasedTasks(data, token): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/admin/getStateWiseJobs`, data, {
      headers: { talentasker: token },
    });
  }
  browsBookings(): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/api/postjob/fetch_all`
    );
  }
  searchByName(data, token): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/admin/namesearching`, data, {
      headers: { talentasker: token },
    });
  }
  releasePaymentToProvider(data, token): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/api/admin/status`,
      data,
      { headers: { talentasker: token } }
    );
  }
  getMyTasks(data,token): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/api/postjob/get`,
      data,
      { headers: { talentasker: token } }
    );
  }
  getTasksBySearch(data, token): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/admin/postjob_search`, data, {
      headers: { talentasker: token },
    });
  }
  getBookingsBySearch(data, token): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/admin/bookings_search`, data, {
      headers: { talentasker: token },
    });
  }
  deleteTask(data, token) {
    return this.http.post(`${this.baseUrl}/api/admin/deletetask`, data, {
      headers: { talentasker: token },
    });
  }
  getFilteredTasks(data, token) {
    return this.http.post(
      `${this.baseUrl}/api/admin/fetchtask`,
      data,
      { headers: { talentasker: token } }
    );
  }
  //  Hire Providers
  hireProviders(data, token): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/api/hire/taskers`,
      data,
      { headers: { talentasker: token } }
    );
  }
  browseCategory(): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/categories`);
  }
  bookingDetails(data, token): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/hire/`, data, {
      headers: { talentasker: token },
    });
  }
  ediComment(data, token): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/admin/updatecomment`, data, {
      headers: { talentasker: token },
    });
  }
  fetchAllbookings(data, token): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/api/admin/bookings`,
      data,
      { headers: { talentasker: token } }
    );
  }
  fetchAllCustomers(data, token): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/api/admin/filters`,
      data,
      { headers: { talentasker: token } }
    );
  }
  downloadReports(data, token): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/api/admin/Reports`,
      data,
      { headers: { talentasker: token }, responseType: "arraybuffer" }
    );
  }
  deleteComments(data, token): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/admin/deletecomment`, data, {
      headers: { talentasker: token },
    });
  }
  deleteOffer(data, token): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/api/admin/deleteprovidertask`,
      data,
      { headers: { talentasker: token } }
    );
  }
  // get details with ratings also;
  fetchUserDetails(id, token): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/admin/`, id, {
      headers: { talentasker: token },
    });
  }
  // get only details.Api from apps
  getUserDetails(id): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/api/customer/fetch`,
      id
    );
  }
  // Block or unblock

  blockUnBlock(data, token): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/api/admin/blockOrUnblock`,
      data,
      { headers: { talentasker: token } }
    );
  }
  getMyOfferedTasks(data, token): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/offers/getOfferedPosts`, data, {
      headers: { talentasker: token },
    });
  }
  // Account verification
  verifyCustomer(data, token): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/api/admin/verification`,
      data,
      { headers: { talentasker: token } }
    );
  }
  // Refferal
  getReferralData(data, token): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/admin/referral`, data, {
      headers: { talentasker: token },
    });
  }
  fetchUserReffaral(data, token): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/api/admin/fetchEarnedReferrals`,
      data,
      { headers: { talentasker: token } }
    );
  }
  makeAsPaid(obj, token): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/admin/referralpaid`, obj, {
      headers: { talentasker: token },
    });
  }
  // Chat Update
  updateChatMessages(obj, token): Observable<any> {
    return this.http.put(`${this.baseUrl}/api/postjob/offer_Chat_Update`, obj, {
      headers: { talentasker: token },
    });
  }
  // Delete chat messages
  deleteChatMessages(obj, token): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        talentasker: token,
      }),
      body: {
        postID: obj.postID,
        offeredUserID: obj.offeredUserID,
        userID: obj.userID,
        message: obj.message,
        timeStamp: obj.timeStamp,
      },
    };
    return this.http.delete(`${this.baseUrl}/api/postjob/chatDelete`, options);
  }
  fetchNotifications(data, token): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/api/admin/fetchAdminNotifications`,
      data,
      { headers: { talentasker: token } }
    );
  }
  fetchUserIDS(data, token): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/admin/fetchCustomerIDs`, data, {
      headers: { talentasker: token },
    });
  }
  sendNotifications(data, token): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/admin/pushnotification`, data, {
      headers: { talentasker: token },
    });
  }
  deleteNotifiCation(data, token): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        talentasker: token,
      }),
      body: {
        notifyID: data.notifyID,
        userID: data.userID,
        type: data.type,
      },
    };
    return this.http.delete(
      `${this.baseUrl}/api/admin/deleteNotification`,
      options
    );
  }
  deleteAllNotifiCations(data, token): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        talentasker: token,
      }),
      body: {
        userID: data.userID,
        type: data.type,
      },
    };
    return this.http.delete(
      `${this.baseUrl}/api/admin/deleteAllNotification`,
      options
    );
  }
  settingsCategoryInsert(data, token): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/categories/insert`, data, {
      headers: { talentasker: token },
    });
  }
  updateAmount(data, token): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/api/categories/updateamountdata`,
      data,
      { headers: { talentasker: token } }
    );
  }
  deleteCategory(data, token): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        talentasker: token,
      }),
      body: {
        categoryId: data.categoryId,
      },
    };
    return this.http.delete(`${this.baseUrl}/api/categories/delete`, options);
  }
}
